// The catalog (GET /catalog) is loaded once per session and reused for the
// generator and for turning docType and subCategory ids into labels.
import { getCatalog, type CatalogTahap } from "../api";

let cache: { key: string; promise: Promise<CatalogTahap[]> } | null = null;

export function loadCatalog(sessionKey: string): Promise<CatalogTahap[]> {
  if (!cache || cache.key !== sessionKey) {
    const promise = getCatalog().catch((err) => {
      cache = null;
      throw err;
    });
    cache = { key: sessionKey, promise };
  }
  return cache.promise;
}

export function resetCatalog(): void {
  cache = null;
}

/** "rancangan_kontrak" to "Rancangan Kontrak" when the catalog has no label for it. */
export function humanize(id: string): string {
  const s = id.replace(/[_-]+/g, " ").trim();
  if (!s) return id;
  return s
    .split(/\s+/)
    .map((w) => w[0]!.toUpperCase() + w.slice(1))
    .join(" ");
}

export function docTypeLabel(catalog: CatalogTahap[] | null, docType: string): string {
  for (const t of catalog ?? []) {
    const d = t.documentTypes.find((x) => x.id === docType);
    if (d) return d.label;
  }
  return humanize(docType);
}

export function subLabel(catalog: CatalogTahap[] | null, docType: string, sub: string): string {
  for (const t of catalog ?? []) {
    const d = t.documentTypes.find((x) => x.id === docType);
    const s = d?.subCategories.find((x) => x.id === sub);
    if (s) return s.label;
  }
  return humanize(sub);
}
